import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, useLocation, withRouter } from "react-router-dom";
import * as RoutePath from "../../shared/utils/routeLink";
import * as Variable from "../../shared/utils/variables";
import * as ActionTypes from "../../store/actions/actionTypes";
import { toast } from "react-toastify";
import "./CareerDetail.scss";
import Image from "../../shared/component/UI/Image";
import {
	CreditCardIcon,
	GradCapIconOutline,
	HeartIconFilled,
	HeartIconOutline,
	LightbulbIcon,
	NewspaperClippingIcon,
	RoundedStarIcon,
} from "../../shared/component/svg/Icons";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import LoadingComponent from "../../shared/component/LoadingComponent/LoadingComponent";
import MediaViewer from "../../shared/component/MediaViewer/MediaViewer";
import CardContainer from "../../shared/component/CardContainer/CardContainer";
import { MajorCard } from "../../shared/component/Card/Card";
import makeRequest from "../../shared/utils/request";
import { generateRequestOptions } from "../../shared/utils/apiEndPoints";
import { Helmet } from "react-helmet";

const CareerDetail = ({ ENV_NAME, isAuthenticated, fetchingAddRemoveFavorites, ...props }) => {
	const [isLoading, setIsLoading] = useState(false);
	const [careerData, setCareerData] = useState(null);
	const [showMediaModal, setShowMediaModal] = useState({
		show: false,
		idx: -1,
	});
	let location = useLocation();

	// Get the id of a career
	// If they don't have any career, redirect to the home page
	useEffect(() => {
		if (location?.pathname?.includes(RoutePath.CAREER_DETAIL)) {
			let url = location?.pathname;
			let id = url?.substring(url.lastIndexOf("/") + 1);
			if (id !== RoutePath.CAREER_DETAIL && !isNaN(id)) {
				getCareerDetails(id);
			} else {
				toast.error(Variable.CAREER_NOT_FOUND[ENV_NAME]);
				props.history.push(RoutePath.ROOT);
			}
		}
	}, [location]); // eslint-disable-line

	// Get career details
	// If API error, redirect to the home page
	const getCareerDetails = async (id) => {
		setIsLoading(true);
		let res = await makeRequest(generateRequestOptions("careerDetail", { urlParams: id + "/" }));
		if (res.code === 200) {
			setCareerData(res.data);
		} else {
			toast.error(Variable.CAREER_NOT_FOUND[ENV_NAME]);
			props.history.push(RoutePath.ROOT);
		}
		setIsLoading(false);
	};

	return (
		<div className="career-detail">
			{careerData?.career_name && (
				<Helmet>
					<title>
						Direktori Kampus Terbaik di Indonesia - Portal Sekolah - {careerData?.career_name || "-"}
					</title>
				</Helmet>
			)}
			{isLoading ? (
				<LoadingComponent />
			) : (
				<>
					<div className="bg-container">
						<div className="container header-card">
							<div className="img-header">
								<Image
									src={careerData?.career_featured_image}
									onClick={() => {
										if (!careerData?.career_featured_image) return;
										setShowMediaModal({ show: true, idx: 0 });
									}}
								/>
								<Image
									src={careerData?.career_second_image}
									onClick={() => {
										if (!careerData?.career_second_image) return;
										setShowMediaModal({ show: true, idx: 1 });
									}}
								/>
								<Image
									src={careerData?.career_third_image}
									onClick={() => {
										if (!careerData?.career_third_image) return;
										setShowMediaModal({ show: true, idx: 2 });
									}}
								/>
							</div>
							<div className="header-body">
								<div className="d-flex-desktop justify-content-between align-items-center">
									<div className="d-flex align-items-center">
										<Image src={careerData?.career_icon} className="career-logo" />
										<h2 className="text-label-dark-gray-2 mb-0">
											<strong>{careerData?.career_name || "-"}</strong>
										</h2>
									</div>
									<button
										className="btn fav-button"
										onClick={() => {
											if (fetchingAddRemoveFavorites) return;
											if (isAuthenticated) {
												// call API
												props.addRemoveFavorite(
													careerData?.is_favourite ? "remove" : "add",
													"career",
													careerData?.is_favourite ? careerData?.fav_obj_id : careerData?.id,
													(res) => {
														if (careerData?.is_favourite) {
															setCareerData((p) => ({
																...p,
																fav_obj_id: null,
																is_favourite: false,
															}));
														} else {
															setCareerData((p) => ({
																...p,
																fav_obj_id: res?.data?.id,
																is_favourite: true,
															}));
														}
													}
												);
											} else {
												props.openLoginModal();
											}
										}}
									>
										{careerData?.is_favourite ? (
											<>
												<HeartIconFilled
													className="me-xs"
													width="2rem"
													height="2rem"
													fill="#F24822"
												/>
												{Variable.REMOVE_FROM_FAVORITES[ENV_NAME]}
											</>
										) : (
											<>
												<HeartIconOutline
													className="me-xs"
													width="2rem"
													height="2rem"
													stroke="#F24822"
												/>
												{Variable.ADD_TO_FAVORITES[ENV_NAME]}
											</>
										)}
									</button>
								</div>
								<div className="divider" />
								<div className="d-flex-desktop text-center">
									<div className="w-100 px-sm">
										<div className="text-label-dark-gray mb-sm">{Variable.SALARY[ENV_NAME]}</div>
										<div className="flex-all-center">
											<CreditCardIcon
												width="2.4rem"
												height="2.4rem"
												className="me-xxs mw-2p4rem"
												stroke="#193560"
											/>
											<h4 className="text-label-dark-gray-2 my-xxs font-weight-medium">
												{`${Variable.START_FROM[ENV_NAME]} `}
												<strong>{careerData?.career_starting_salary || "-"}</strong>
											</h4>
										</div>
									</div>
									<div className="w-100 px-sm">
										<div className="text-label-dark-gray mb-sm">
											{Variable.MIN_DEGREE[ENV_NAME]}
										</div>
										<div className="flex-all-center">
											<GradCapIconOutline
												width="2.4rem"
												height="2.4rem"
												className="me-xxs mw-2p4rem"
												stroke="#193560"
											/>
											<h4 className="text-label-dark-gray-2 my-xxs">
												{`${Variable.START_FROM[ENV_NAME]} `}
												<strong>{careerData?.career_minimum_degree || "-"}</strong>
											</h4>
										</div>
									</div>
									<div className="w-100 px-sm">
										<div className="text-label-dark-gray mb-sm">
											{Variable.CERTIFICATION[ENV_NAME]}
										</div>
										<div className="flex-all-center">
											<NewspaperClippingIcon
												width="2.4rem"
												height="2.4rem"
												className="me-xxs mw-2p4rem"
												stroke="#193560"
											/>
											<h4 className="text-label-dark-gray-2 my-xxs">
												<strong>{careerData?.career_certificates || "-"}</strong>
											</h4>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<section className="container detail-section">
						<h2 className="header text-center">{Variable.CAREER_DESCRIPTION[ENV_NAME]}</h2>
						<div
							className="force-styling-wysiwyg"
							dangerouslySetInnerHTML={{
								__html: careerData?.career_description || "",
							}}
						/>
					</section>
					{careerData?.career_fact_stats?.length > 0 && (
						<div className="bg-container">
							<section className="container detail-section career-desc mb-0">
								<h2 className="header text-center">{Variable.FACT_STATS[ENV_NAME]}</h2>
								<div className="fact-cont">
									{careerData?.career_fact_stats?.map((i, idx) => (
										<div className="fact-item" key={idx}>
											<LightbulbIcon
												className="mb-sm d-block"
												width="3.2rem"
												height="3.2rem"
												stroke="#193560"
											/>
											<div
												className="force-styling-wysiwyg"
												dangerouslySetInnerHTML={{
													__html: i || "-",
												}}
											/>
										</div>
									))}
								</div>
							</section>
						</div>
					)}
					{careerData?.career_role_and_responsibilities?.length > 0 && (
						<section className="container detail-section">
							<h2 className="header text-center mb-std">{Variable.ROLE_RESPONSIBILITIES[ENV_NAME]}</h2>
							{careerData?.career_role_and_responsibilities?.map((i, idx) => (
								<div className="responsibility-item" key={idx}>
									<RoundedStarIcon width="1.4rem" height="1.4rem" fill="#193560" className="me-xs" />
									<div
										className="force-styling-wysiwyg"
										dangerouslySetInnerHTML={{
											__html: i || "-",
										}}
									/>
								</div>
							))}
						</section>
					)}
					{careerData?.career_knowledge_and_skills_required?.length > 0 && (
						<section
							className={`detail-section required-skills-cont ${
								careerData?.career_path_items?.length > 0 || careerData?.career_path_description
									? "mb-0"
									: ""
							}`}
						>
							<h2 className="header text-center">{Variable.REQUIRED_SKILLS[ENV_NAME]}</h2>
							<div className="facilities-cont">
								{careerData?.career_knowledge_and_skills_required?.map((i, idx) => (
									<div
										className="facilities-cont-item no-before"
										key={idx}
										dangerouslySetInnerHTML={{
											__html: i || "-",
										}}
									/>
								))}
							</div>
						</section>
					)}
					{(careerData?.career_path_items?.length > 0 || careerData?.career_path_description) && (
						<section className="detail-section career-path">
							<h2 className="header text-center">{Variable.CAREER_PATH[ENV_NAME]}</h2>
							{careerData?.career_path_description && (
								<div
									className="mb-lg force-styling-wysiwyg"
									dangerouslySetInnerHTML={{
										__html: careerData?.career_path_description || "",
									}}
								/>
							)}
							<div className="career-path-cont">
								<div className="crc-left">
									{(careerData?.career_path_items || [])
										?.slice(0, Math.max(5, Math.ceil(careerData?.career_path_items?.length / 2)))
										?.map((i, idx) => (
											<div className="crc-item" key={"crc-left-" + idx}>
												<div className="crc-num">{idx + 1}</div>
												<div className="crc-desc">{i}</div>
											</div>
										))}
								</div>
								{careerData?.career_path_items?.length > 5 && (
									<div className="crc-right">
										{(careerData?.career_path_items || [])
											?.slice(
												Math.max(5, Math.ceil(careerData?.career_path_items?.length / 2)),
												Math.max(careerData?.career_path_items?.length)
											)
											?.map((i, idx) => (
												<div className="crc-item" key={"crc-right-" + idx}>
													<div className="crc-num">
														{Math.max(
															5,
															Math.ceil(careerData?.career_path_items?.length / 2)
														) +
															idx +
															1}
													</div>
													<div className="crc-desc">{i}</div>
												</div>
											))}
									</div>
								)}
							</div>
						</section>
					)}
					{careerData?.major?.length > 0 && (
						<div className="bg-container mb-0 pb-xl">
							<section className="container detail-section mb-0">
								<div className="d-flex align-items-center">
									<h2 className="header text-center">{Variable.RELATED_MAJOR[ENV_NAME]}</h2>

									<Link to={RoutePath.MAJOR} className="mb-lg text-decoration-none">
										<span className="view-all-text mb-0">{Variable.VIEW_ALL[ENV_NAME]}</span>
									</Link>
								</div>
								<CardContainer>
									{(careerData?.major || []).map((i, idx) => (
										<Link
											key={i?.id || idx}
											to={RoutePath.MAJOR_DETAIL + "/" + i?.id}
											className="text-decoration-none text-label-dark-gray-2"
										>
											<MajorCard data={i} onClick={() => {}} ENV_NAME={ENV_NAME} hideFavorite />
										</Link>
									))}
								</CardContainer>
							</section>
						</div>
					)}
					<MediaViewer
						ENV_NAME={ENV_NAME}
						show={showMediaModal?.show}
						idx={showMediaModal?.idx}
						medias={[
							careerData?.career_featured_image,
							careerData?.career_second_image,
							careerData?.career_third_image,
						]}
						thumbs={[
							careerData?.career_featured_image,
							careerData?.career_second_image,
							careerData?.career_third_image,
						]}
						onHide={() => setShowMediaModal({ show: false, idx: 0 })}
					/>
				</>
			)}
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		isAuthenticated: state.auth.isAuthenticated,
		ENV_NAME: state.auth.selectedEnvironment || "bhs",
		fetchingAddRemoveFavorites: state.auth.fetchingAddRemoveFavorites,
	};
};

const mapStateToDispatch = (dispatch) => {
	return {
		openLoginModal: () =>
			dispatch({
				type: ActionTypes.OPEN_LOGIN_MODAL,
			}),
		addRemoveFavorite: (action, type, id, onSuccess = null, onFail = null) =>
			dispatch({
				type: ActionTypes.ADD_REMOVE_FAVORITE,
				data: { action, type, id },
				onSuccess,
				onFail,
			}),
	};
};

export default connect(mapStateToProps, mapStateToDispatch)(withRouter(CareerDetail));
